import React from 'react';
import { ReactComponent as HidePasswordSvg } from '@images/auth/hide-password-login.svg';

export const HidePasswordIcon = () => {
  return <HidePasswordSvg />;
};
